import React, { useState } from 'react';
import { Redirect, Link } from 'react-router-dom';
import CamposReuniao from './CamposReuniao';
import { CabecalhoForm, SecaoForm, AreaArquivo, RodapeForm, EtapasForm } from '../../layouts/FormUI';
import MenuHorizontal from '../../layouts/MenuHorizontal';
import MenuVertical from '../../layouts/MenuVertical';
import { Icon, Form, Button } from 'semantic-ui-react';
import api from '../../../api';
import { formatDocumento } from '../../../utils/formatador';
import * as FormValidator from "../../../utils/formValidator";

const CadastrarVotacao = ({ match: { params }, history }) => {
  const [condominio, setCondominio] = useState({});
  const [responsaveis, setResponsaveis] = useState([]);
  const [convocacao, setConvocacao] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const [votacao, setVotacao] = useState({
    condominio: params.id,
    dataFinalReuniao: '',
    dataInicioReuniao: '',
    horarioFinalReuniao: '',
    horarioReuniao: '',
    local: '',
    presidente: '0',
    secretario: '0',
    titulo: '',
    urlTransmissao: '',
    votacaoIniciada: true,
  });

  useState(() => {
    const init = async () => {
      try {
        setCondominio(await api.condominio.findSimpleById(params.id));
        setResponsaveis(await api.responsavel.find(params.id).then(it => it.responsaveis));
        setLoading(false);
      } catch(e) {
        setErrors((e.data && e.data.errors) || {});
      }
    };
    init();
  }, []);

  const getResponsaveis = label => [
    { key: '0', value: '0', text: `Selecione o ${label}` },
    ...responsaveis.map(it => ({
      key: it._id,
      value: it._id,
      text: `${it.nome} - ${formatDocumento(it.documento)}`,
    }))
  ];

  const onChangeFile = ({ target: { files } }) => {
    if (files && files[0] && files[0].type === 'application/pdf') {
      if (FormValidator.sizeLimit(files[0], process.env.REACT_APP_LIMIT_UPLOAD)) {
        setConvocacao(files[0]);
        setErrors({});
      } else {
        setErrors({ arquivo: `Permitido arquivos de até ${process.env.REACT_APP_LIMIT_UPLOAD}mb` });
      }
    }
  };

  const changeVotacao = (name, value) => setVotacao(p => ({ ...p, [name]: value }));
  const onChangeSelect = (_, { name, value }) => changeVotacao(name, value);
  const onChange = ({ target: { name, value } }) => changeVotacao(name, value);

  const validate = () => {
    const errs = {};

    if (FormValidator.isVazio(votacao.titulo)) {
      errs.titulo = 'Titulo é obrigatório';
    }

    if (FormValidator.isVazio(votacao.dataInicioReuniao)) {
      errs.dataInicioReuniao = 'Data início é obrigatório';
    } else if (!FormValidator.isDataVotacao(votacao.dataInicioReuniao)) {
      errs.dataInicioReuniao = 'Digite uma data maior ou igual a data atual';
    }

    if (FormValidator.isVazio(votacao.dataFinalReuniao)) {
      errs.dataFinalReuniao = 'Data limite é obrigatório';
    } else if (!FormValidator.isDataVotacao(votacao.dataFinalReuniao)) {
      errs.dataFinalReuniao = 'Digite uma data maior ou igual a data atual';
    }

    if (!FormValidator.isVazio(votacao.urlTransmissao) && !FormValidator.isUrl(votacao.urlTransmissao)) {
      errs.urlTransmissao = 'Digite uma url válida';
    }

    return errs;
  };

  const buildForm = () => {
    const formData = new FormData();

    formData.append("arquivo", convocacao);

    Object.keys(votacao).forEach(item => {
      formData.append(item, votacao[item]);
    });

    return formData;
  };

  const onSubmit = async () => {
    const errs = validate();
    setErrors(errs);

    if (Object.keys(errs).length === 0) {
      setLoading(true);
      try {
        const result = await api.votacao.create(buildForm());
        history.push(`/condominios/${params.id}/votacoes/editar/${result._id}/perguntas`);
      } catch (e) {
        setErrors((e.data && e.data.errors) || {});
      }
      setLoading(false);
    }
  };

  const voltar = `/condominios/${params.id}/votacoes`;

  return (
    <>
      {!!errors.global && <Redirect to="/" />}
      <MenuHorizontal />
      <div className="corpo-dashboard">
        <MenuVertical condominio={condominio} />
        <div className="va-imp-pagina">
          <CabecalhoForm
            voltar={voltar}
            voltarTexto="Votações"
            titulo="Cadastrar votação"
            descricao="Informe os dados da reunião. Na próxima etapa você cadastra as perguntas e pautas."
          />
          <EtapasForm etapas={['Sobre a reunião', 'Perguntas / pautas']} atual={0} />
          <Form loading={loading} autoComplete="off" className="va-imp" onSubmit={e => { e.preventDefault(); onSubmit(); }}>
            <SecaoForm icone="file pdf outline" titulo="Documento de convocação" descricao="Anexe o PDF da convocação para os moradores consultarem no aplicativo (opcional).">
              <AreaArquivo
                id="arquivo"
                arquivo={convocacao}
                accept="application/pdf"
                onChange={onChangeFile}
                titulo="Arraste o PDF aqui ou clique para selecionar"
                dica={`Somente PDF · até ${process.env.REACT_APP_LIMIT_UPLOAD}mb`}
                erro={errors.arquivo}
              />
            </SecaoForm>
            <CamposReuniao
              valores={votacao}
              errors={errors}
              onChange={onChange}
              onChangeSelect={onChangeSelect}
              getResponsaveis={getResponsaveis}
            />
            <RodapeForm>
              <Button type="submit" loading={loading} disabled={loading} className="btn-ui-1" size="large" icon labelPosition="right">
                Próximo: perguntas e pautas <Icon name="right arrow" />
              </Button>
              <Link to={voltar} className="ui basic large button">Cancelar</Link>
            </RodapeForm>
          </Form>
        </div>
      </div>
    </>
  );
};

export default CadastrarVotacao;
